import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import AppContainer from "../Structure/AppContainer";
import PermissionContext from "../../Context/PermissionContext";
import AuthContext from "../../Context/AuthContext";
import ajaxUser from "../../util/remote/ajaxUser";
import ajaxRolePermissionDistribution from "../../util/remote/ajaxRolePermissionDistribution";
const UserPermissionsDistribution = () => {
  const { userId } = useContext(AuthContext);
  const { permissionList } = useContext(PermissionContext) || {};
  const [usePermissions, setUsePermissions] = useState([]); // allocated
  const [selectedPermissions, setSelectedPermissions] = useState([]); // new
  const [removedPermissions, setRemovedPermissions] = useState([]); // to remove
  const { userID } = useParams();
  useEffect(() => {
    fetchUserPermissions();
  }, [userID]);
  const fetchUserPermissions = async () => {
    if (!userID) return;
    const response = await ajaxUser.getUserPermissionCodess({
      user_id: userID,
    });
    if (response.status === "OK") {
      setUsePermissions(response.details || []);
      setRemovedPermissions([]);
      setSelectedPermissions([]);
    } else {
      toast.error(response.message);
    }
  };
  const handleCheck = (permId, alreadyAllocated) => {
    if (alreadyAllocated) {
      if (removedPermissions.includes(permId)) {
        setRemovedPermissions(removedPermissions.filter((id) => id !== permId));
      } else {
        setRemovedPermissions([...removedPermissions, permId]);
      }
    } else {
      if (selectedPermissions.includes(permId)) {
        setSelectedPermissions(
          selectedPermissions.filter((id) => id !== permId)
        );
      } else {
        setSelectedPermissions([...selectedPermissions, permId]);
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedPermissions.length === 0 && removedPermissions.length === 0) {
      toast.error("No changes selected");
      return;
    }
    const data = {
      addPermissions: selectedPermissions,
      removePermissions: removedPermissions,
      user_id: userID,
      added_by: userId,
    };
    const server_response =
      await ajaxRolePermissionDistribution.createPermissionDistribution(data);
    if (server_response.status === "OK") {
      toast.success(server_response.message);
      fetchUserPermissions();
    } else {
      toast.error(server_response.message);
    }
  };
  return (
    <AppContainer title="Permissions Distribution">
      <Toaster />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card p-3">
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead className="table-dark">
                    <tr>
                      <th className="text-light">#</th>
                      <th className="text-light">Permission Code</th>
                      <th className="text-light">Description</th>
                      <th className="text-light text-center">
                        Allocate / Remove
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissionList?.length > 0 ? (
                      permissionList.map((perm, index) => {
                        const alreadyAllocated = usePermissions.some(
                          (p) => parseInt(p.id) === parseInt(perm.permission_id)
                        );
                        const isRemoved = removedPermissions.includes(
                          perm.permission_id
                        );
                        const isNew = selectedPermissions.includes(
                          perm.permission_id
                        );
                        let rowClass = "";
                        if (isRemoved)
                          rowClass = "text-danger"; // red for removal
                        else if (isNew)
                          rowClass = "text-primary"; // blue for newly added
                        else if (alreadyAllocated) rowClass = "text-success"; // green for allocated
                        return (
                          <tr key={perm.permission_id} className={rowClass}>
                            <td>{index + 1}</td>
                            <td>{perm.permission_code}</td>
                            <td>{perm.permission_description}</td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={alreadyAllocated ? !isRemoved : isNew}
                                onChange={() =>
                                  handleCheck(
                                    perm.permission_id,
                                    alreadyAllocated
                                  )
                                }
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center py-3">
                          No permissions found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="text-end mt-3">
                {/* <button
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={
                    selectedPermissions.length === 0 &&
                    removedPermissions.length === 0
                  }
                >
                  Save Changes
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default UserPermissionsDistribution;
